// Copyright © 2023 Move Closer
import { __decorate } from "tslib";
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import VideoPlayerYouTube from './versions/VideoPlayerYouTube';
import VideoPlayerFile from './versions/VideoPlayerFile';
import VideoPlayerOnNetwork from './versions/VideoPlayerOnNetwork';
let VideoPlayer = class VideoPlayer extends Vue {
    constructor() {
        super(...arguments);
        this.forcePlayer = null;
        this.forceRandom = null;
        this.baseVideoProps = {
            ads: this.ads,
            baseVideoMetadata: {
                '@context': 'https://schema.org',
                '@type': 'VideoObject',
                ...this.baseVideoMetadata
            },
            eventBus: this.eventBus,
            origin: this.origin,
            shouldInit: this.noThumbnail,
            videoAdsTag: this.videoAdsTag,
            videoAttrId: this.videoAttrId,
            videoClass: this.videoClass
        };
    }
    get forcedYoutube() {
        return (this.forcePlayer === 'youtube') ||
            (typeof this.forceType === 'undefined' && this.hasYTVideo);
    }
    get forcedHls() {
        return (this.forcePlayer === 'hls') && this.hasFileVideo;
    }
    get forcedOnNetwork() {
        return (this.forcePlayer === 'on') && this.hasOnNetwork;
    }
    get hasOnNetwork() {
        return typeof this.video.onNetworkUrl === 'string' && this.video.onNetworkUrl.length > 0;
    }
    get hasYTVideo() {
        return typeof this.video.url === 'string' && this.video.url.length > 0;
    }
    get hasFileVideo() {
        return !!this.video.file && typeof this.video.file === 'object' && (!!this.video.file.url || !!this.video.file.m3u8);
    }
    onVideoInit() {
        this.$emit('init');
    }
    onVideoPause() {
        this.$emit('pause');
    }
    onVideoPlay() {
        this.$emit('play');
    }
    watchEvents() {
        if (!this.eventBus) {
            return;
        }
        this.eventBus.handle('ui:video-player.play', this.onPlay);
        this.eventBus.handle('ui:video-player.pause', this.onPause);
        this.eventBus.handle('ui:video-player.state-changed', this.onStateChanged);
    }
    onPlay(event) {
        if (typeof event.payload === 'undefined') {
            return;
        }
        const { playerId, autoplay, muted } = event.payload;
        if (playerId !== this.videoAttrId) {
            return;
        }
        this.eventBus.emit('ui:video-player.play', {
            playerId: this.forcePlayer + this.videoAttrId,
            autoplay: autoplay,
            muted: muted
        });
    }
    onPause(event) {
        if (typeof event.payload === 'undefined') {
            return;
        }
        const { playerId } = event.payload;
        if (playerId !== this.videoAttrId) {
            return;
        }
        this.eventBus.emit('ui:video-player.pause', {
            playerId: this.forcePlayer + this.videoAttrId
        });
    }
    onStateChanged(event) {
        if (typeof event.payload === 'undefined') {
            return;
        }
        const { playerId, state } = event.payload;
        if (playerId !== this.videoAttrId) {
            return;
        }
        this.eventBus.emit('ui:video-player.state-changed', {
            playerId: this.forcePlayer + this.videoAttrId,
            state: state
        });
    }
};
__decorate([
    Inject({ from: 'eventBus' })
], VideoPlayer.prototype, "eventBus", void 0);
__decorate([
    Prop({
        type: Object,
        required: true
    })
], VideoPlayer.prototype, "baseVideoMetadata", void 0);
__decorate([
    Prop({
        type: String,
        required: true
    })
], VideoPlayer.prototype, "origin", void 0);
__decorate([
    Prop({
        type: String,
        required: true
    })
], VideoPlayer.prototype, "videoAttrId", void 0);
__decorate([
    Prop({
        type: String,
        required: false
    })
], VideoPlayer.prototype, "videoAdsTag", void 0);
__decorate([
    Prop({
        type: String,
        required: false
    })
], VideoPlayer.prototype, "videoClass", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: true
    })
], VideoPlayer.prototype, "ads", void 0);
__decorate([
    Prop({
        type: String,
        required: false
    })
], VideoPlayer.prototype, "forceType", void 0);
__decorate([
    Prop({
        type: Object,
        required: true
    })
], VideoPlayer.prototype, "video", void 0);
__decorate([
    Prop({
        type: Object,
        required: false
    })
], VideoPlayer.prototype, "videoSettings", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: false
    })
], VideoPlayer.prototype, "noThumbnail", void 0);
VideoPlayer = __decorate([
    Component({
        name: 'VideoPlayer',
        components: {
            VideoPlayerFile,
            VideoPlayerYouTube,
            VideoPlayerOnNetwork
        },
        mounted() {
            // this.watchEvents()
            if (this.forceType) {
                this.forcePlayer = this.forceType;
            }
            this.playerVideoSettings = { ...this.videoSettings };
            if (this.playerVideoSettings) {
                this.playerVideoSettings.hls = this.playerVideoSettings.hls * ((!this.video.file) ? 0 : 1);
                this.playerVideoSettings.youtube = this.playerVideoSettings.youtube * ((!this.video.url) ? 0 : 1);
                this.playerVideoSettings.on = this.playerVideoSettings.on * ((!this.video.onNetworkUrl) ? 0 : 1);
                let total = this.playerVideoSettings.hls + this.playerVideoSettings.youtube + this.playerVideoSettings.on;
                if (total === 0) {
                    this.playerVideoSettings.hls = ((!this.video.file) ? 0 : 1);
                    this.playerVideoSettings.youtube = ((!this.video.url) ? 0 : 1);
                    this.playerVideoSettings.on = ((!this.video.onNetworkUrl) ? 0 : 1);
                    total = this.playerVideoSettings.hls + this.playerVideoSettings.youtube + this.playerVideoSettings.on;
                }
                this.playerVideoSettings.hls = this.playerVideoSettings.hls / total;
                this.playerVideoSettings.youtube = this.playerVideoSettings.youtube / total;
                this.playerVideoSettings.on = this.playerVideoSettings.on / total;
                const poolSettings = [
                    {
                        type: 'youtube',
                        range: [0, this.playerVideoSettings.youtube]
                    },
                    {
                        type: 'hls',
                        range: [this.playerVideoSettings.youtube, this.playerVideoSettings.youtube + this.playerVideoSettings.hls]
                    },
                    {
                        type: 'on',
                        range: [
                            this.playerVideoSettings.youtube,
                            this.playerVideoSettings.youtube + this.playerVideoSettings.hls + this.playerVideoSettings.on
                        ]
                    }
                ];
                this.forceRandom = Math.random();
                for (const setting of poolSettings) {
                    if (setting.range[1] === 1 || (setting.range[0] <= this.forceRandom && this.forceRandom <= setting.range[1])) {
                        this.forcePlayer = setting.type;
                        break;
                    }
                }
                // console.log('poolSettings', poolSettings)
                // console.log('forcePlayer', this.forcePlayer)
                // console.log('playerVideoSettings', this.playerVideoSettings)
            }
        },
        template: `
    <VideoPlayerFile v-if="forcedHls" v-bind="baseVideoProps" :video="video.file"
                     @init="onVideoInit" @pause="onVideoPause" @play="onVideoPlay" />

    <VideoPlayerOnNetwork v-else-if="forcedOnNetwork" v-bind="baseVideoProps" :video-src="video.onNetworkUrl"
                          @init="onVideoInit" @pause="onVideoPause" @play="onVideoPlay" />

    <VideoPlayerYouTube v-else-if="forcedYoutube" v-bind="baseVideoProps" :videoSrc="video.url"
                        @init="onVideoInit" @pause="onVideoPause" @play="onVideoPlay" />
  `
    })
], VideoPlayer);
export { VideoPlayer };
export default VideoPlayer;
